import * as jsxRuntime from "C:\\Users\\admin\\spanishlearnigplatform\\bouyon 17\\node_modules\\react\\jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment